import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { memo } from "react";

const STICKER_SIZE = 164;

const STICKERS = {
  // 원래 있던 배달 스티커 (접근 가능 여부 확인 필요)
  delivery:
    "https://d1jj76g3lut4fe.cloudfront.net/saved_colors/108066/dyxxapkz7b8VRwpN.json",
};

const StickerComponent = memo(({ src }: { src: string }) => (
  <DotLottieReact
    src={src}
    loop
    autoplay
    style={{ width: STICKER_SIZE, height: STICKER_SIZE }}
  />
));

export default function StickerPicker() {
  return (
    <div className="grid grid-cols-2 gap-2 p-2">
      {Object.entries(STICKERS).map(([key, src]) => (
        <StickerComponent key={key} src={src} />
      ))}
    </div>
  );
}
